var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('el-tree',{ref:"dataConfigTree",staticClass:"tree",attrs:{"data":_vm.dictionaryData,"props":_vm.defaultProps,"accordion":"","node-key":"itemid","highlight-current":true},on:{"node-click":_vm.handleNodeClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[_c('span',{attrs:{"title":node.label}},[_vm._v(_vm._s(node.label))])])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }